import { TTranslationKey } from '../../features/translate/types';
import { ERelatedPointType } from './related-points.consts';

export const RELATED_POINT_TYPE_LABEL_KEY: Record<string, TTranslationKey> = {
  [ERelatedPointType.RELATES_TO]: 'relates_to',
};
